import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG, CFG_MONO_FONT } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

/** The applied-voucher chip: a monospaced code pill (matching the read-only `CodePill`) with a
 *  trailing × remove button. */
export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  align-self: flex-start;
  padding: 1px 4px 1px 8px;
  border-radius: 6px;
  background: ${CFG.washHover};
`;

export const ChipCode = styled(Text)`
  font-family: ${CFG_MONO_FONT};
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${FINISH.rowSublabelMuted};
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${FINISH.rowSublabelMuted};
  cursor: pointer;
  transition:
    color 120ms ease,
    background 120ms ease;

  &:hover:not(:disabled) {
    color: ${CFG.foreground};
    background: ${CFG.hairlineStrong};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    display: block;
  }
`;
